/**
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @param {Record<string, any>} obj
 * @param {string} prefix
 * @param {string} sep
 * @returns {Record<string, unknown>}
 */
export function flatten(obj, prefix = '', sep = '.') {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    const fullKey = prefix ? `${prefix}${sep}${key}` : key;
    return {
      ...acc,
      ...(value && typeof value === 'object' && !Array.isArray(value)
        ? flatten(value, fullKey, sep)
        : { [fullKey]: value })
    };
  }, {});
}
